module.exports = __webpack_public_path__ + "static/img/yy11.af4a5f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/rongyu/yy11.png
// module id = JN/f
// module chunks = 1